import { Button } from 'components/atoms';
import { Helmet } from 'react-helmet-async';
import { PiCaretLeftBold } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetClientModuleConfiguration } from 'services/configuration';
import { ITopBarProps } from 'types/components/topbar/topbar.interface';
import './TopBar.scss';

const TopBar = ({
  children,
  title = '',
  path,
  customBackItem,
  topbarContent,
  isChildrenVisible = true,
  size = 'default',
  useHelmet = true,
  hideHeader = false,
  hideBackButton = false,
}: ITopBarProps) => {
  const navigate = useNavigate();

  const configurationModule = useGetClientModuleConfiguration();
  return (
    <div className={`topbar-wrapper ${size}`}>
      <div className='topbar'>
        {useHelmet && (
          <Helmet>
            <title>
              {configurationModule.data?.clientName ?? 'MagelUP'}{' '}
              {typeof title === 'string' ? title : ''}
            </title>
          </Helmet>
        )}
        {!hideHeader && (
          <div className='header'>
            {customBackItem ?? (
              <Button
                isClear
                onlyIcon
                onClick={() =>
                  path ? navigate(`/${path}`, { replace: true }) : navigate(-1)
                }>
                <Button.Icon icon={<PiCaretLeftBold />} />
              </Button>
            )}
            {title && <div className='title'>{title}</div>}
          </div>
        )}
        <div className='children'>{topbarContent}</div>
      </div>
      {isChildrenVisible && children}
    </div>
  );
};

export default TopBar;
